/**
 * 稿件查询
 */
'user strict';
angular.module('manageSysManageContributionQueryModule', []).controller('manageSysManageContributionQueryCtrl', [
    '$scope',
    'trsHttpService',
    'modalDialog',
    '$q',
    function($scope, trsHttpService, modalDialog, $q) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态函数开始]
         * @return {[type]} [description]
         */
        function initStatus() {
            // 分页参数
            $scope.page = {
                CURRPAGE: 1, // 当前页
                PAGESIZE: 20, // 一页显示数据量
                ITEMCOUNT: 0, // 总数据量
                PAGECOUNT: 1, // 总页数
                gotoPage: 1, // 跳转到页数
            };
            // 下拉参数
            $scope.dropDownMenu = {
                allProduce: [
                    { name: 'APP', value: '1' },
                    { name: '网站', value: '2' },
                ],
                selectedProduce: { name: 'APP', value: '1' },
                searchTypes: [
                    // 检索下拉类型
                    { name: '全部', value: '' },
                    { name: '稿件ID', value: 'DocID' },
                    { name: '操作人', value: 'operUser' },
                    { name: '标题', value: 'docTitle' },
                ],
                selectedSearchType: { name: '全部', value: '' },
            };
            // 时间范围参数
            $scope.time = {};
            // 搜索关键词
            $scope.keyword = '';
            // 列表数据
            $scope.items = [];
            // 请求参数
            $scope.params = {};
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData 接口--请求媒体详情列表]
         * @return {[type]} [description]
         */
        function requestData() {
            var deffer = $q.defer();
            var searchParams,
                methodname = 'queryForAllWebsiteDoc';
            searchParams = {
                PAGESIZE: $scope.page.PAGESIZE,
                PAGEINDEX: $scope.page.CURRPAGE,
                searchFields: [
                    {
                        // 关键词（searchField为空时，为全部，DocID为稿件id，docTitle为标题，operUser为操作人；keywords里面直接传关键词）
                        searchField: $scope.dropDownMenu.selectedSearchType.value,
                        keywords: $scope.keyword,
                    },
                    {
                        // 时间范围（keywords里面传时间范围："2019-07-12,2019-07-13"）
                        searchField: 'timeType',
                        keywords:
                            JSON.stringify($scope.time) == '{}'
                                ? ''
                                : $scope.time.startDate === ''
                                ? ''
                                : [$scope.time.startDate, $scope.time.endDate].join(),
                    },
                    {
                        // 稿件类型（keywords里面传稿件类型id）
                        searchField: 'docType',
                        keywords: '',
                    },
                    {
                        // 是否只查看当前用户，传false
                        searchField: 'isOnlyMine',
                        keywords: false,
                    },
                    {
                        // 站点id（keywords里面传站点id）
                        searchField: 'siteid',
                        keywords: '',
                    },
                ],
            };
            if ($scope.dropDownMenu.selectedProduce.value == 1) {
                // app渠道
                methodname = 'queryForAllAppDoc';
            }
            // $scope.items = [];
            // $scope.page.ITEMCOUNT = 0;
            // $scope.page.PAGECOUNT = 1;
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    trsHttpService.getWCMRootUrl(),
                    {
                        serviceid: 'mlf_hybasesearch',
                        methodname: methodname,
                        searchParams: JSON.stringify(searchParams),
                    },
                    'get'
                )
                .then(function(res) {
                    if (res.DATA) {
                        var docIds = [];
                        res.DATA.map(function(item) {
                            docIds.push(item.METADATAID);
                        });
                        // 获取稿件栏目路径、碎片信息和稿件来源
                        if (docIds.length) {
                            getOtherInfo(docIds.join()).then(function(inRes) {
                                inRes.map(function(item, index) {
                                    // 处理碎片信息数据
                                    if (item.TEMPLATES.length == 0) {
                                        item.shardFullName = '碎片ID：无';
                                    } else {
                                        item.shardFullName = [];
                                        item.TEMPLATES.map(function(innerItem) {
                                            item.shardFullName.push('碎片ID：' + innerItem.TEMPID);
                                            item.shardFullName.push('碎片名称：' + innerItem.TEMPDESC);
                                        });
                                    }
                                    // 将获取的稿件栏目路径、碎片信息和稿件来源, 拼接到对应的数据内
                                    res.DATA[index] = Object.assign(res.DATA[index], item);
                                });
                                $scope.items = res.DATA;
                            });
                            $scope.items = res.DATA;
                            $scope.page.ITEMCOUNT = res.PAGER.ITEMCOUNT;
                            $scope.page.PAGECOUNT = res.PAGER.PAGECOUNT;
                        } else {
                            $scope.items = res.DATA;
                            $scope.page.ITEMCOUNT = res.PAGER.ITEMCOUNT;
                            $scope.page.PAGECOUNT = res.PAGER.PAGECOUNT;
                        }
                    }
                    deffer.resolve(res);
                });
            return deffer.promise;
        }

        /**
         * [getOtherInfo description] 接口--获取稿件栏目路径、碎片信息和稿件来源
         * @param   {[type]}  ids  [ids description]
         * @return  {[type]}       [return description]
         */
        function getOtherInfo(ids) {
            var deffer = $q.defer();
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    trsHttpService.getWCMRootUrl(),
                    {
                        serviceid: 'mlf_website',
                        methodname: 'queryChannelPathAndWiget',
                        MetadataIds: ids,
                    },
                    'get'
                )
                .then(function(res) {
                    deffer.resolve(res);
                });
            return deffer.promise;
        }

        /**
         * [exportExcel 接口--导出excel]
         * @return {[type]} [description]
         */
        $scope.exportExcel = function() {
            var searchParams = {
                PAGESIZE: $scope.page.PAGESIZE,
                PAGEINDEX: $scope.page.CURRPAGE,
                searchFields: [
                    {
                        // 关键词（searchField为空时，为全部，DocID为稿件id，docTitle为标题，operUser为操作人；keywords里面直接传关键词）
                        searchField: $scope.dropDownMenu.selectedSearchType.value,
                        keywords: $scope.keyword,
                    },
                    {
                        // 时间范围（keywords里面传时间范围："2019-07-12,2019-07-13"）
                        searchField: 'timeType',
                        keywords: JSON.stringify($scope.time) == '{}' ? '' : [$scope.time.startDate, $scope.time.endDate].join(),
                    },
                    {
                        // 稿件类型（keywords里面传稿件类型id）
                        searchField: 'docType',
                        keywords: '',
                    },
                    {
                        // 是否只查看当前用户，传false
                        searchField: 'isOnlyMine',
                        keywords: false,
                    },
                    {
                        // 站点id（keywords里面传站点id）
                        searchField: 'siteid',
                        keywords: '',
                    },
                ],
            };
            var exportUrl = `/wcm/exportDocList.do?MediaType=${$scope.dropDownMenu.selectedProduce.value}&SearchParams=${JSON.stringify(
                searchParams
            )}`;
            exportUrl = encodeURI(exportUrl);
            window.open(exportUrl);
            // redirectPost('/wcm/exportDocList.do', {
            //     MediaType: $scope.dropDownMenu.selectedProduce.value,
            //     SearchParams: JSON.stringify(searchParams),
            // })
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param   {[type]}  key    [key description] 请求对象参数key
         * @param   {[type]}  value  [value description] 请求对象值
         * @return  {[type]}         [return description]
         */
        $scope.queryByDropdown = function(key, value) {
            $scope.page.CURRPAGE = 1;
            $scope.page.gotoPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [fullTextSearch description] 搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        };

        /**
         * [selectPageNum description] 选择一页要显示的数据量
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            // $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            // $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.page.gotoPage = $scope.page.CURRPAGE;
            // $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            // $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.page.gotoPage > $scope.page.PAGECOUNT) {
                $scope.page.gotoPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.page.gotoPage;
            // $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            // $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            requestData();
        };
    },
]);
